import React, { useState, useEffect } from "react";
import { Container, Paper, Typography, Avatar, List, ListItem, ListItemText, CircularProgress, Alert, Box,IconButton } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import api from "../utils/api";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const Profile = ({ email }) => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchProfile = async () => {
    try {
      const response = await api.get("/punch/profile", { params: { email } });
      setProfileData(response.data);
      setLoading(false);
    } catch (err) {
      setError(err.response?.data?.message || "Error fetching profile.");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [email]);

  // Fallback back function in case there's no history
  const handleBack = () => {
    navigate("/dashboard"); // default route if no history exists
  }

  return (
    <Container maxWidth="sm">
      <Paper elevation={4} sx={{ p: 4, my: 4, borderRadius: 2 }}>
        {/* Arrow back button */}
        <IconButton onClick={(handleBack)} sx={{ mb: 2 }}>
          <ArrowBackIcon />
        </IconButton>
        {loading ? (
          <CircularProgress />
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Avatar sx={{ width: 100, height: 100, mb: 2 }}>
                <PersonIcon fontSize="large" />
              </Avatar>
              <Typography variant="h5">{profileData.name}</Typography>
              <Typography variant="subtitle1">{profileData.position}</Typography>
            </Box>
            <List sx={{ mt: 2 }}>
              <ListItem>
                <ListItemText primary="Email" secondary={email} />
              </ListItem>
              <ListItem>
                <ListItemText primary="Attendance Records" secondary={`${profileData.attendanceCount} entries`} />
              </ListItem>
            </List>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default Profile;
